import { render, staticRenderFns } from "./supplierDeliveryDistribution.vue?vue&type=template&id=63e0be36&scoped=true"
import script from "./supplierDeliveryDistribution.vue?vue&type=script&lang=js"
export * from "./supplierDeliveryDistribution.vue?vue&type=script&lang=js"
import style0 from "./supplierDeliveryDistribution.vue?vue&type=style&index=0&id=63e0be36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e0be36",
  null
  
)

export default component.exports